import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "sx" }
const _hoisted_2 = { class: "sx-grid" }
const _hoisted_3 = { class: "sx-field" }
const _hoisted_4 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_5 = { class: "sx-field" }
const _hoisted_6 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_7 = {
  key: 1,
  class: "sx-help"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_10 = {
  class: "sx-card",
  "aria-labelledby": "bk-list-title"
}
const _hoisted_11 = { class: "sx-list-head" }
const _hoisted_12 = { id: "bk-list-title" }
const _hoisted_13 = { class: "sx-count" }
const _hoisted_14 = { class: "sx-search" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "sx-load-error",
  role: "alert"
}
const _hoisted_17 = {
  key: 2,
  class: "sx-empty"
}
const _hoisted_18 = {
  key: 3,
  class: "sx-rows"
}
const _hoisted_19 = {
  class: "sx-avatar",
  "aria-hidden": "true"
}
const _hoisted_20 = { class: "sx-main" }
const _hoisted_21 = {
  key: 0,
  class: "sx-code"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "sx-meta" }
const _hoisted_24 = { class: "sx-tag" }
const _hoisted_25 = { class: "sx-tag" }
const _hoisted_26 = { class: "sx-actions" }
const _hoisted_27 = ["aria-label", "onClick"]
const _hoisted_28 = ["aria-label", "title", "disabled", "onClick"]
const _hoisted_29 = {
  id: "editBankModal",
  ref: "editModal",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "editBankModalLabel",
  "aria-hidden": "true"
}
const _hoisted_30 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_31 = { class: "modal-body" }
const _hoisted_32 = { class: "sx-field" }
const _hoisted_33 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_34 = { class: "sx-field" }
const _hoisted_35 = { class: "modal-footer" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[30] || (_cache[30] = _createElementVNode("header", { class: "sx-head" }, [
      _createElementVNode("span", { class: "sx-eyebrow" }, "Paramètres"),
      _createElementVNode("h1", { class: "sx-title" }, "Banques"),
      _createElementVNode("p", { class: "sx-sub" }, "Banques proposées pour les RIB des clients et des utilisateurs (virements, paiements).")
    ], -1)),
    _createVNode(_component_SettingsNav),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "sx-card sx-form-card",
        novalidate: "",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _cache[13] || (_cache[13] = _createElementVNode("header", { class: "sx-card-head" }, [
          _createElementVNode("span", { class: "sx-card-icon" }, [
            _createElementVNode("i", {
              class: "ph ph-bank",
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h2", null, "Nouvelle banque"),
            _createElementVNode("p", null, "Elle sera proposée dans les formulaires de RIB.")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { for: "bk-new-name" }, [
            _createTextVNode("Nom de la banque "),
            _createElementVNode("span", {
              class: "sx-req",
              "aria-hidden": "true"
            }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            id: "bk-new-name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bank.name) = $event)),
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.name }]),
            maxlength: "100",
            placeholder: "Ex. Attijariwafa Bank",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (delete _ctx.errors.name))
          }, null, 34), [
            [_vModelText, _ctx.bank.name]
          ]),
          (_ctx.errors.name)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.errors.name), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { for: "bk-new-code" }, "Code de la banque", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "bk-new-code",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bank.code) = $event)),
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.code }]),
            maxlength: "20",
            placeholder: "Ex. 007",
            onInput: _cache[3] || (_cache[3] = ($event: any) => (delete _ctx.errors.code))
          }, null, 34), [
            [_vModelText, _ctx.bank.code]
          ]),
          (_ctx.errors.code)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.errors.code), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, "Code bancaire (3 premiers chiffres du RIB), facultatif."))
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary sx-submit",
          disabled: _ctx.saving
        }, [
          (_ctx.saving)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9))
            : _createCommentVNode("", true),
          _cache[12] || (_cache[12] = _createTextVNode(" Ajouter la banque ", -1))
        ], 8, _hoisted_8)
      ], 32),
      _createElementVNode("section", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h2", _hoisted_12, [
            _cache[14] || (_cache[14] = _createTextVNode("Banques ", -1)),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.banks.length), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[15] || (_cache[15] = _createElementVNode("i", {
              class: "ph ph-magnifying-glass",
              "aria-hidden": "true"
            }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search) = $event)),
              type: "search",
              placeholder: "Rechercher une banque…",
              "aria-label": "Rechercher une banque"
            }, null, 512), [
              [_vModelText, _ctx.search]
            ])
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                return _createElementVNode("span", {
                  key: n,
                  class: "sx-skel"
                })
              }), 64))
            ]))
          : (_ctx.loadError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _cache[16] || (_cache[16] = _createElementVNode("i", {
                  class: "ph ph-warning-circle",
                  "aria-hidden": "true"
                }, null, -1)),
                _cache[17] || (_cache[17] = _createTextVNode(" Impossible de charger les banques. ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-light",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fetchBanks && _ctx.fetchBanks(...args)))
                }, "Réessayer")
              ]))
            : (!_ctx.filtered.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _cache[18] || (_cache[18] = _createElementVNode("i", {
                    class: "ph ph-bank",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.search ? "Aucune banque ne correspond à votre recherche." : "Aucune banque pour le moment."), 1)
                ]))
              : (_openBlock(), _createElementBlock("ul", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtered, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.id,
                      class: _normalizeClass(["sx-row", { 'is-new': item.id === _ctx.lastAddedId }])
                    }, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.initials(item.name)), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                        _createElementVNode("small", null, [
                          (item.code)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.code), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_22, "Sans code"))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, [
                          _cache[19] || (_cache[19] = _createElementVNode("i", {
                            class: "ph ph-user",
                            "aria-hidden": "true"
                          }, null, -1)),
                          _createElementVNode("b", null, _toDisplayString(_ctx.num(item.NbUsers)), 1),
                          _cache[20] || (_cache[20] = _createTextVNode(" utilisateur(s)", -1))
                        ]),
                        _createElementVNode("span", _hoisted_25, [
                          _cache[21] || (_cache[21] = _createElementVNode("i", {
                            class: "ph ph-storefront",
                            "aria-hidden": "true"
                          }, null, -1)),
                          _createElementVNode("b", null, _toDisplayString(_ctx.num(item.NbClient)), 1),
                          _cache[22] || (_cache[22] = _createTextVNode(" client(s)", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "sx-icon-btn",
                          "aria-label": `Modifier ${item.name}`,
                          title: "Modifier",
                          onClick: ($event: any) => (_ctx.openEditModal(item.id))
                        }, _cache[23] || (_cache[23] = [
                          _createElementVNode("i", {
                            class: "ph ph-pencil-simple",
                            "aria-hidden": "true"
                          }, null, -1)
                        ]), 8, _hoisted_27),
                        _createElementVNode("button", {
                          type: "button",
                          class: "sx-icon-btn is-danger",
                          "aria-label": `Supprimer ${item.name}`,
                          title: _ctx.num(item.NbClient) > 0 ? 'Impossible : banque utilisée par des clients' : 'Supprimer',
                          disabled: _ctx.num(item.NbClient) > 0,
                          onClick: ($event: any) => (_ctx.deleteType(item.id))
                        }, _cache[24] || (_cache[24] = [
                          _createElementVNode("i", {
                            class: "ph ph-trash",
                            "aria-hidden": "true"
                          }, null, -1)
                        ]), 8, _hoisted_28)
                      ])
                    ], 2))
                  }), 128))
                ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("form", {
          class: "modal-content",
          novalidate: "",
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateBank && _ctx.updateBank(...args)), ["prevent"]))
        }, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h2", {
              id: "editBankModalLabel",
              class: "modal-title"
            }, "Modifier la banque"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { for: "bk-edit-name" }, [
                _createTextVNode("Nom de la banque "),
                _createElementVNode("span", {
                  class: "sx-req",
                  "aria-hidden": "true"
                }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "bk-edit-name",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editBank.name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.editErrors.name }]),
                maxlength: "100"
              }, null, 2), [
                [_vModelText, _ctx.editBank.name]
              ]),
              (_ctx.editErrors.name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.editErrors.name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _cache[26] || (_cache[26] = _createElementVNode("label", { for: "bk-edit-code" }, "Code de la banque", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "bk-edit-code",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editBank.code) = $event)),
                type: "text",
                class: "form-control",
                maxlength: "20"
              }, null, 512), [
                [_vModelText, _ctx.editBank.code]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _cache[28] || (_cache[28] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              "data-bs-dismiss": "modal"
            }, "Annuler", -1)),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary",
              disabled: _ctx.savingEdit
            }, [
              (_ctx.savingEdit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_37))
                : _createCommentVNode("", true),
              _cache[27] || (_cache[27] = _createTextVNode(" Enregistrer ", -1))
            ], 8, _hoisted_36)
          ])
        ], 32)
      ])
    ], 512)
  ]))
}